import { Box, Stack } from "@mui/material";
import { Card, Text } from "@src/appV2/redesign/system/ui-components";

interface RolesEmptyStateCardProps {
  title: string;
  description?: React.ReactNode;
  children: React.ReactNode;
}

export function RolesEmptyStateCard(props: RolesEmptyStateCardProps) {
  const { title, description, children } = props;

  return (
    // TODO: Extract this gradient with a more generic name
    <Card
      sx={(theme) => ({
        background: theme.palette.documents?.neutral.gradient,
      })}
    >
      <Stack
        sx={{
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          gap: 5,
          padding: 10,
          textAlign: "center",
        }}
      >
        <Text semibold variant="h4" sx={{ textWrap: "balance" }}>
          {title}
        </Text>

        {description ? (
          <Text variant="body2" sx={{ textWrap: "balance" }}>
            {description}
          </Text>
        ) : null}

        <Box sx={{ width: "100%", marginTop: 5 }}>{children}</Box>
      </Stack>
    </Card>
  );
}
